<template>
  <h2 class="w-full">{{ $t('ling-gan-zhong-xin') }}</h2>
  <nuxt-link :to="{ path: '/template' }" class="more-btn">
    {{ $t('cha-kan-geng-duo') }}
    <iconpark-icon name="arrowright" size="16"></iconpark-icon>
  </nuxt-link>

  <Templates
    :list="calList"
    :columns="5"
    :showScenario="false"
    :rem="true"
    :loading="pending"
    :template_source="TEMPLATE_SOURCE.HOMEPAGE"
  />
  <div
    v-if="calList.length < total"
    ref="wp"
    v-intersect="handleInView"
    class="way-point flex-y-center items-center justify-center"
  >
    <div v-if="pending">
      <a-spin />
    </div>
  </div>
  <Divider v-if="calList.length === total && total > 0">
    <template #text>
      {{ $t('yi-jing-dao-di-la') }}
      <span v-if="isChinese()">
        {{ $t('key-0') }}
      </span>
      <nuxt-link
        v-if="isChinese()"
        type="text"
        class="bottom-more"
        :to="{ name: PageKey.TEMPLATE }"
        aria-label="go templates"
      >
        {{ $t('cha-kan-geng-duo') }}
      </nuxt-link>
    </template>
  </Divider>
</template>

<script lang="ts" setup>
import Templates from '~/components/templates/index.vue'
import { getHomeTemplateLists } from '~/api'
import type { TemplateParams } from '~/api/interface/template.ts'
import { getTagByOuterId } from '~/api/module/tags.ts'
import { useScrollList } from '~/hooks/useScrollList.ts'
import { useStarPatchList } from '~/hooks/useStarPatch.ts'
import { PageKey } from '~/constants/page'
const nuxtApp = useNuxtApp()

// 灵感列表的数据
// const tag = await useAsyncData(() => getTagByOuterId('start_with_templates'))
let tag: { id: number; name: string }
let tagSearched = false

const { list, pending, next, total, clear } = useScrollList(
  async (params) => {
    if (!tagSearched) {
      const tagRes = await getTagByOuterId('start_with_templates')
      const targetTag = tagRes.data?.[0]
      tagSearched = true
      if (targetTag) {
        tag = targetTag
      }
    }

    const p = {
      sort_rank: 1,
      tag_id: tag.id + '',
      ...params,
    } as TemplateParams

    const res = await getHomeTemplateLists(
      {
        ...p,
        query_star: import.meta.client,
      },
      nuxtApp
    )

    res.data?.results?.forEach((item) => {
      item.query_star = import.meta.client // 标记这些数据没有查询过star
    })

    return res
  },
  {
    key: 'home_inspiration',
    pageSize: 20,
  }
)

const handleInView = (inView: boolean) => {
  if (inView) {
    next()
  }
}

onBeforeUnmount(() => {
  clear()
})
const { calList } = useStarPatchList(list, 3)
</script>

<style lang="scss" scoped>
.way-point {
  padding: 20px 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.bottom-more {
  text-decoration: none !important;
}

.more-btn {
  position: absolute;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  font-size: rem(14);
  line-height: 1;
  color: var(--text-1);
  opacity: 0.6;
  &:hover {
    opacity: 0.9;
  }
}
</style>
